import React from "react";
import { Box, Typography, Tooltip, IconButton } from "@mui/material";
import { FileCopy } from "@mui/icons-material";

function OrderCopyLink({ orderLink, copiedLink, handleCopy }) {
  return (
    <Box sx={{ display: "flex", alignItems: "center", marginBottom: 4 }}>
      <Typography variant="body2" sx={{ flex: 1, wordBreak: "break-word" }}>
        {orderLink}
      </Typography>
      <Tooltip title={copiedLink ? "Скопировано!" : "Копировать ссылку"}>
        <IconButton onClick={() => handleCopy(orderLink, copiedLink)} sx={{ ml: 1 }}>
          <FileCopy />
        </IconButton>
      </Tooltip>
    </Box>
  );
}

export default OrderCopyLink;
